import React from 'react';
import { XMarkIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

const WelcomeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl rounded-2xl shadow-2xl 
                    border border-gray-200/50 dark:border-gray-700/50 max-w-md w-full mx-4
                    animate-fade-in">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200/50 dark:border-gray-700/50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-xl">
              <InformationCircleIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">
              Welcome to EverfieldGPT Beta
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 
                     transition-colors text-gray-500 dark:text-gray-400"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="flex items-center gap-2 mb-4">
            <span className="px-3 py-1 text-xs font-bold rounded-full font-mono
                           bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg">
              GPT-5.6 Sol
            </span>
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Latest model
            </span>
          </div>

          <div className="space-y-3 text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed">
              EverfieldGPT runs on GPT-5.6 Sol through Everfield's secure AI gateway.
            </p>
            
            <div className="bg-blue-50/80 dark:bg-blue-900/20 rounded-xl p-4 border border-blue-200/50 dark:border-blue-800/50">
              <h3 className="font-semibold text-blue-900 dark:text-blue-100 mb-2">
                Privacy & Data
              </h3>
              <p className="text-sm text-blue-800 dark:text-blue-200">
                Your chat history is stored locally in your browser for convenience. 
                No data is retained on our servers.
              </p>
            </div>

          </div>
        </div>

        {/* Footer */}
        <div className="p-6 pt-0">
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white 
                     rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-200
                     shadow-lg hover:shadow-xl modern-button font-medium"
          >
            Get Started
          </button>
            <div className="mt-4 text-xs text-gray-400 text-center">
              For feedback, bugs or issues please contact Luis Perez (<a href="mailto:luis.perez@everfield.com" className="underline hover:text-blue-500">luis.perez@everfield.com</a>)
            </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
